import GroupingsModel from "./GroupingsModel.js";
import GroupingsEditor from "./GroupingsEditor.js";
const install = molten => {
  molten.addPlugin('Model', {
    type: GroupingsModel.TYPE,
    model: GroupingsModel
  });
  molten.addPlugin('ModelEditor', {
    type: GroupingsModel.TYPE,
    editor: GroupingsEditor
  });
};
export default {
  install
};